<template>
  <v-tooltip bottom>
    <v-btn slot="activator" icon class="mx-0" to="/upgrade" target="_blank">
      <img src="https://img.icons8.com/color/48/000000/fairytale.png" height="30px">
      <!-- <v-icon color="purple">alarm</v-icon> -->
    </v-btn>
    <span>Fazer upgrade</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'PBtnUpgrade',
    props: {
      // text: {
      //   type: String
      // }
    },
    methods: {
    },
    computed: {
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PBtnUpgrade.vue